import { Map } from 'mapbox-gl'
import { create } from 'zustand'

import { IGeometry, Setters, State } from './types'
import { initialState } from './state'

export const useMapStore = create<State & Setters>((set) => ({
  ...initialState,
  setMap: (value: Map) => set(() => ({ map: value })),
  setZonePolygons: (value?: IGeometry[]) => set(() => ({ zonePolygons: value })),
  setIsLoadedMap: (isLoadedMap: boolean) => set(() => ({ isLoadedMap })),
  setDrawingTool: ({ isActive, status }) =>
    set(() => ({ drawingTool: { isActive, status } })),
  setIsFlyTo: (isFlyTo: boolean) => set(() => ({ isFlyTo })),
  setMapZoom: (mapZoom: number) => set(() => ({ mapZoom })),
  setHoveredLayer: (layer) => set(() => ({ hoveredLayer: layer })),
  setClickedLayer: (layer) => set(() => ({ clickedLayer: layer })),
}))
